// src/components/ServicesCards.js
import React from "react";
import "./ServicesCards.css";

// The three pillars, framed as the coaching arc an athlete moves through:
// talk daily → train the program → compete with handling. The order is real,
// so it carries a step number.
const services = [
  {
    step: "01",
    title: "Communication",
    points: [
      "A daily communication system covering programming, technique analysis, and any relevant notes.",
      "Guaranteed 24-hour response time via WhatsApp.",
    ],
  },
  {
    step: "02",
    title: "Programming",
    points: [
      "Fully individualized, modern powerlifting programming with recovery, progress, and schedule tracking.",
      "Programming shared and updated via Google Sheets.",
    ],
  },
  {
    step: "03",
    title: "Meet-Day Handling",
    points: [
      "Professional meet-day handling at local and national competitions, included.",
      "Additional fees apply for non-local or national competitions.",
    ],
  },
];

const ServicesCards = () => (
  <ol className="services-cards">
    {services.map((service) => (
      <li key={service.step} className="card">
        <span className="card__step" aria-hidden="true">
          {service.step}
        </span>
        <h3 className="card__title">{service.title}</h3>
        <ul className="card__points">
          {service.points.map((point, i) => (
            <li key={i}>{point}</li>
          ))}
        </ul>
      </li>
    ))}
  </ol>
);

export default ServicesCards;
